import {GetRefundSpecialties} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetSpecialties} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundSpecialties = (): GetRefundSpecialties =>
	new RemoteRefundGetSpecialties(
		makeBFFApiUrl(RefundFlowEndPoints.specialties),
		makeAuthorizeHttpClientDecorator(),
	);
